<template>
	<section class="page-your-plan">
		<header-page :title="$route.meta.title" />
		<div class="plan-content"><your-plan-summary /></div>
	</section>
</template>

<script>
import yourPlanSummary from '@/components/your-plan/your-plan-summary';

export default {
	name: 'page-your-plan',
	components: {
		yourPlanSummary,
	},
};
</script>

<style lang="scss" scoped>
.page-your-plan {
	background: color(background-table);
	min-height: calc(100vh - 80px);
}

.plan-content {
	padding: 28px;

	@media (max-width: 768px) {
		padding: 16px 12px 32px;
	}
}
</style>



// WEBPACK FOOTER //
// src/pages/your-plan/page-your-plan.vue